import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { getLastItem, withRouter } from "../../../shared/utility";
import { classNames } from "primereact/utils";

import EmptyModal from "../../../components/modals/EmptyModal";
import { CustomerDetailsViewModel } from "../../../viewmodels/setup/customers/CustomerDetailsViewModel";

import CustomerDetailsForm from "../../../components/forms/setup/customers/CustomerDetailsForm";
import CustomerWorkOrdersTab from "./customer/CustomerWorkOrdersTab";

const tabs = [
  { name: "Overview", href: "#" },
  { name: "Work Orders", href: "#" },
];

function CustomerDetailsScreen(props) {
  const { addSnackbar, logout } = props;

  const [currentTab, setCurrentTab] = useState(0);

  const { pathname } = useLocation();
  const customerId = getLastItem(pathname);

  const {
    customer,
    getCustomer,
    loading,
    setEmptyModelOpen,
    emptyModal,
    updateCustomer,
  } = CustomerDetailsViewModel(logout, customerId, addSnackbar);

  const onStartDependencides = async function () {
    getCustomer();
  };

  useEffect(() => {
    onStartDependencides();
  }, []);

  const renderComponent = (index) => {
    switch (index) {
      case 0:
        return (
          <div key={0} className="bg-white">
            {loading ? (
              "loading"
            ) : (
              <CustomerDetailsForm
                actionCall={updateCustomer}
                customer={customer}
                isEdit={true}
                setOpen={{}}
                title="test"
                setEmptyModelOpen={setEmptyModelOpen}
              />
            )}
          </div>
        );

      case 1:
        return (
          <div key={1} className="bg-white">
            <CustomerWorkOrdersTab workOrders={customer.work_orders} />
          </div>
        );

      default:
        return (
          <div key={1000} className="bg-white">
            Could not load page, please try again
          </div>
        );
    }
  };

  return (
    <div className="bg-gray-50">
      <header className="bg-white shadow sticky top-0 mx-6">
        <div className="flex p-4">
          <h1 className="text-3xl font-bold text-gray-900">
            {loading ? "Loading..." : customer.name}
          </h1>
        </div>
      </header>
      <main>
        <div className="p-6">
          {/* Content starts here */}

          {/* tab here */}
          <div className="hide-for-print">
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                id="tabs"
                name="tabs"
                className="block w-full  border-gray-300 rounded-md"
                defaultValue={tabs[currentTab].name}
              >
                {tabs.map((tab, index) => (
                  <option key={index}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                aria-label="Tabs"
              >
                {tabs.map((tab, index) => (
                  <a
                    key={tab.name}
                    href={tab.href}
                    className={classNames(
                      index === currentTab
                        ? "text-gray-900"
                        : "text-gray-500 hover:text-gray-700",
                      index === 0 ? "rounded-l-lg" : "",
                      index === tabs.length - 1 ? "rounded-r-lg" : "",
                      "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                    )}
                    aria-current={index === currentTab ? "page" : undefined}
                    onClick={() => setCurrentTab(index)}
                  >
                    <span>{tab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        index === currentTab
                          ? "bg-indigo-500"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>
          </div>

          {/* {tab content starts below} */}
          <div className="px-4 py-2 sm:px-0">
            <div className="sm:col-span-9 border-b border-gray-200">
              {tabs.map((item, index) =>
                index === currentTab ? renderComponent(index) : null
              )}
            </div>
          </div>
        </div>
      </main>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomerDetailsScreen)
);
